<script>
    import _ from 'lodash'
    import * as types from '../store/types'

    export default {
        props: {
            sid: {
                type: String,
                required: false,
                default: () => _.uuid()
            },
            preloaded: {
                type: Object,
                default: null
            }
        },
        computed: {
            items () {
                return this.$store.getters[types.messages.getters.items](this.sid)
            }
        },
        created () {
            if (this.preloaded) {
                this.$store.commit(types.messages.mutations.got, {
                    sid: this.sid,
                    items: this.preloaded
                })
            }
        },
        destroyed () {
            this.forget()
        },
        methods: {
            forget () {
                this.$store.dispatch(types.messages.actions.forget, { sid: this.sid })
            }
        },
        render () {
            return this.$scopedSlots.default({
                sid: this.sid,
                data: _.get(this.items, 'data', []),
                meta: _.get(this.items, 'meta'),
                forget: this.forget
            })
        }
    }
</script>
